import React from 'react';
import { elevesUrls } from 'containers/Eleves/urls';
import { TabsWithUnderline } from 'components/Tabs/TabsWithUnderline';
import { useSchoolGoTo } from 'containers/App/useSchoolGoTo';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface Props {
  eleveId: string;
  className?: string;
}

export function NavigationTabs(props: Props) {
  const { className, eleveId } = props;
  const { t } = useTranslation(['eleve']);
  const location = useLocation();
  const goTo = useSchoolGoTo();
  const tabs = [
    {
      label: t('eleve:informationGenerales'),
      id: `${elevesUrls.eleveDetails(eleveId)}${location.search}`,
      current: location.pathname.includes('general'),
    },
    {
      label: t('eleve:presences'),
      id: `${elevesUrls.eleveDetailsPresentisme(eleveId)}${location.search}`,
      current: location.pathname.includes('presences'),
    },
  ];
  return (
    <div className={className}>
      <TabsWithUnderline onChange={goTo} tabs={tabs} display="flex" />
    </div>
  );
}
